// #MODULE - ExpSdkJs
// > Author: Saurabh Chauhan
// > Create Date: 01/01/2017
// ##DESCRIPTION: AMD module to do client side experiment checking and splitting.
// Simplest usage is:
// Experiment.detect( experiments, callback );
// where the experiments is a list of experiments in the campaign, i.e. [ 320, 321, 322 ]
// and the callback will host the logic for individual experiments to trigger UI updates.
{
  const $ = require('jquery');
  const _ = require('underscore');
  const Cookie = require('@component/common/src/util/Cookie');
  const Globals = require('@component/common/src/util/Globals');
  const Logger = require('@component/common/src/util/Logger');
  const ClientSideStorage = require('@component/common/src/util/ClientSideStorage');
  const TagManagerUtil = require('@component/common/src/util/TagManagerUtil');
  const RequestContext = require('@component/common/src/util/RequestContext');
  let ExpSdkJs = {
    getLocation: () => window.location,
  };
  function getDefaultHostBasedOnEnv() {
    if (ExpSdkJs.getLocation().href.indexOf('codemacys.fds') > -1) {
      return '//mcom-expcore.fds.com';
    }
    if (ExpSdkJs.getLocation().href.indexOf('codebloomingdales.fds') > -1) {
      return '//bcom-expcore.fds.com';
    }
    if (ExpSdkJs.getLocation().href.indexOf('macys.com') > -1) {
      return '//expcore.macys.com';
    }
    if (ExpSdkJs.getLocation().href.indexOf('bloomingdales.com') > -1) {
      return '//expcore.bloomingdales.com';
    }
    if (ExpSdkJs.getLocation().href.indexOf('mcom') > -1) {
      return '//mcom-expcore.fds.com';
    }
    if (ExpSdkJs.getLocation().href.indexOf('bcom') > -1) {
      return '//bcom-expcore.fds.com';
    }
    if (ExpSdkJs.getLocation().href.indexOf('bloomingdales.fds') > -1) {
      return '//bcom-expcore.fds.com';
    }
    return '//mcom-expcore.fds.com';
  }

  function includes(list, value) {
    return list.includes(value);
  }

  // *** Configurations for Experimentation 2.0 Module ***
  ExpSdkJs = _.defaults(
    {
      COMMON: {
        expCookieName: 'SEED',
        expSessionKey: 'ExpMetaData',
        apiSessionKey: 'expEndpoint',
        sessionTTL: 1000 * 60 * 60 * 24, // 24 hours in millisecond
        apiEndpoint: Globals.getValue('props.experimentationHost') || getDefaultHostBasedOnEnv(),
        expTagssessionTTL: 1000 * 60 * 60 * 0.5, // 30 minutes in millisecond
        expTagsSessionKey: 'ExpTagsFired',
      },
      MEW: {
        sessionTTL: 1000 * 60 * 60 * 6, // 6 hours in milliseconds
      },
      env: '',
      brand: '',
    },
    ExpSdkJs,
  );

  ExpSdkJs.init = function () {
    ExpSdkJs.setEnv(); // Determine agent whether Desktop or MEW
    ExpSdkJs.setBrand(); // Determine whether MCOM or BCOM
  };
  ExpSdkJs.saveSegmentCookie = function (response) {
    let experiments;
    // resp could be the jqXhr object or data
    // so we want to weed out the jqXhr object
    if (typeof response !== 'undefined' && typeof response.always === 'undefined') {
      experiments = JSON.stringify(response);
      console.log(experiments);
      // Cookie.set('SEGMENT', experiments); // , { expires: expireTime });
    } /* else {
      ExpSdkJs.set(ExpSdkJs.getCookie() || {});
    }
    if (ExpSdkJs.queue) {
      for (let i = 0, l = ExpSdkJs.queue.length; i < l; i++) {
        ExpSdkJs.queue[i](ExpSdkJs.data);
      }
      delete ExpSdkJs.queue;
    } */
  };
  ExpSdkJs.set = function (data) {
    ExpSdkJs.data = data;
  };
  ExpSdkJs.getCookie = function (cookieName) {
    let cookie;
    const loc = ExpSdkJs.getLocation();
    if (cookieName) {
      cookie = Cookie.get(cookieName);
      return cookie;
    }
    // implement manual cookie override for testing purposes
    const param = loc.search.match(/[?|&]experiment=([^&]+)/) || loc.search.match(/[?|&]segment=([^&]+)/);
    if (param) {
      Logger.log('Overriding experimentation.');
      return ExpSdkJs.decode(`{"EXPERIMENT":[${param[1]}]}`);
    }
    // get regular cookie value
    cookie = Cookie.get('SEGMENT');
    if (cookie) {
      return ExpSdkJs.decode(cookie);
    }
    return undefined;
  };

  ExpSdkJs.decode = function (ck) {
    let cookie;
    const result = {};
    try {
      cookie = $.parseJSON(ck).EXPERIMENT;
      for (let i = 0, l = cookie.length; i < l; i++) {
        result[cookie[i]] = cookie[i];
      }
    } catch (e) {} // eslint-disable-line no-empty
    return result;
  };
  // reset experiment running -- remove cookie and get new one
  // Experiment.reset = function ( callback ) {
  //     Cookie.remove( this.expCookieName );
  //     this.data = undefined;
  //     this.fetch( callback );
  // };
  ExpSdkJs.getExpIds = function () {
    const expArray = [];
    return expArray.concat(ExpSdkJs.getDesktopServerSideExperiments()).concat(ExpSdkJs.getDesktopClientSideExperiments());
  };
  ExpSdkJs.getMewExpIds = function () {
    ExpSdkJs.init();
    const defObj = $.Deferred();
    const expArray = ExpSdkJs.getExpIds();
    defObj.resolve(expArray);
    defObj.promise();
    return defObj;
  };

  ExpSdkJs.getAllSelectedRecipes = function () {
    ExpSdkJs.init();
    const defObj = $.Deferred();
    let expArray = [];
    const session = ExpSdkJs.getExpSession(ExpSdkJs.COMMON.expSessionKey);
    if (!session || ExpSdkJs.isExpSessionExpired() || !ExpSdkJs.isSignedInSame()) {
      ExpSdkJs.fetchExpData().always((newSession) => {
        if (_.isObject(newSession) && newSession.selectedRecipes) {
          expArray = newSession.selectedRecipes;
          defObj.resolve(expArray);
        } else {
          defObj.resolve(expArray);
        }
      });
    } else if (session.selectedRecipes) {
      // Desktop Session data present , find it in the session.
      defObj.resolve(session.selectedRecipes);
    } else {
      defObj.resolve(expArray);
    }
    defObj.promise();
    return defObj;
  };

  ExpSdkJs.getSelectedRecipesForExperiment = function (experimentRecipes) {
    ExpSdkJs.init();
    const defObj = $.Deferred();
    const selectedRecipes = [];
    const sessionRecipes = ExpSdkJs.getExpIds();
    if (sessionRecipes && sessionRecipes.length > 0) {
      _.forEach(sessionRecipes, (rec) => {
        if (_.contains(experimentRecipes, rec)) {
          selectedRecipes.push(rec);
        }
      });
    }
    defObj.resolve(selectedRecipes);
    defObj.promise();
    return defObj;
  };

  ExpSdkJs.getDesktopClientSideExperiments = function () {
    // Convert the CSV after the pipe into array
    const cookie = Cookie.get(ExpSdkJs.COMMON.expCookieName);
    let parsedExpString;
    let expArray;
    if (cookie && decodeURIComponent(cookie).indexOf('|') > 0) {
      parsedExpString = decodeURIComponent(cookie).split('|')[1];
    }
    if (parsedExpString) {
      expArray = parsedExpString.split(',');
      ExpSdkJs.expArray = expArray;
      return expArray;
    }
    return [];
  };
  // detect current experiment running from list of
  // passed experiments.
  //
  // example:
  //    Segmentation.detect( [220, 221, 222], function ( experiment ) {
  //        // 220 or 221 or 222 or undefined (in case of failed framework)
  //        console.log( experiment );
  //    } );
  //
  ExpSdkJs.detect = function (exps, callback) {
    let experiments = exps;
    // Added by Mercury DEV team to turn-off frontend experiments
    // if QE_TEST=mercury1_92_false, remove if SEGMENT cookie exist and do not call experimentation API
    // this is used by QA teams to do regression test when necessary
    const mercuryCookie = Cookie.get('QE_TEST');
    if (mercuryCookie && mercuryCookie.includes('mercury1_92_false')) {
      Cookie.remove(ExpSdkJs.COMMON.expCookieName);
      return;
    }
    ExpSdkJs.list((expArray) => {
      // split string experiments value
      if (typeof experiments === 'string') {
        experiments = experiments.split(/[\s,]+/);
      }
      // convert all input to array
      if (!$.isArray(experiments)) {
        experiments = [experiments];
      }
      // lookup for fist matching value in 2 arrays
      for (let i = 0, l = experiments.length; i < l; i++) {
        if (expArray[experiments[i]]) {
          return typeof callback === 'function' && callback(experiments[i]);
        }
      }
      if (typeof callback === 'function') {
        callback();
      }
      return true;
    });
  };
  // fetch list of current session segments/experiments.
  // returns hash of experiment ids as first argument to
  // callback passed.
  //
  // example:
  //    ExpSdkJs.list( function ( list ) {
  //        console.log( list ); // { 9:9, 71:71, 11:11 }
  //    } );
  ExpSdkJs.list = function (callback) {
    // there are already request running, queue call
    if (ExpSdkJs.queue) {
      if (typeof callback === 'function') {
        this.queue.push(callback);
      }
      return false;
    }
    // get segments from cookie
    if (!ExpSdkJs.expArray) {
      ExpSdkJs.getExpIds();
    }
    // segments already parsed
    if (ExpSdkJs.expArray) {
      return typeof callback === 'function' && callback(ExpSdkJs.expArray);
    }
    // create queue, to avoid multiple request to server
    ExpSdkJs.queue = [];
    return undefined;
  };
  // make call to Experementation Framework service to get
  // Experiment cookie with list of segments/experiments for
  // current session. after fetching cookie, will process
  // queue and call optional callback passed.
  ExpSdkJs.fetchExpData = function () {
    const defObj = $.Deferred();
    const api = ExpSdkJs.COMMON.apiEndpoint;
    const session = ClientSideStorage.getSession(ExpSdkJs.COMMON.expSessionKey);
    // if meta data already exists in session storage &&
    // session NOT expired
    if (session && !ExpSdkJs.isExpSessionExpired() && ExpSdkJs.isSignedInSame()) {
      defObj.resolve(session);
    } else if (api !== undefined && api !== null) {
      ExpSdkJs.callExperimentationAPI().always(() => {
        const newSession = ClientSideStorage.getSession(ExpSdkJs.COMMON.expSessionKey);
        defObj.resolve(JSON.parse(newSession));
      });
    } else {
      defObj.reject();
    }
    defObj.promise();
    return defObj;
  };
  ExpSdkJs.setEnv = function () {
    let isMobile = false;
    const clientSideObject = RequestContext.generateClientSideRequest();
    const cookies = clientSideObject.cookies;
    const device = RequestContext.getDeviceTypeFromCookie(cookies);
    if (ExpSdkJs.getLocation().href.indexOf('//m.') > -1) {
      isMobile = true;
    } else if (device !== undefined && device !== 'PC') {
      isMobile = true;
    }
    ExpSdkJs.env = isMobile ? 'MEW' : 'DESKTOP';
    return ExpSdkJs.env;
  };

  ExpSdkJs.setBrand = function () {
    let brand;
    if (ExpSdkJs.getLocation().href.indexOf('macys') > -1) {
      brand = 'mcom';
    } else if (ExpSdkJs.getLocation().href.indexOf('mcom') > -1) {
      brand = 'mcom';
    } else if (ExpSdkJs.getLocation().href.indexOf('bloomingdales') > -1) {
      brand = 'bcom';
    } else if (ExpSdkJs.getLocation().href.indexOf('bcom') > -1) {
      brand = 'bcom';
    } else {
      brand = 'mcom';
    }
    ExpSdkJs.brand = brand;
    return ExpSdkJs.brand;
  };

  ExpSdkJs.callExperimentationAPI = function () {
    let api = ExpSdkJs.COMMON.apiEndpoint;
    const cookie = Cookie.get(ExpSdkJs.COMMON.expCookieName);
    let sid;

    if (!cookie) {
      sid = '';
    } else {
      sid = `?sid=${cookie}`;
    }
    // Desktop Only: extracts only campaign id for each experiment
    api += `/filteredExperiments${sid}`;
    if (api) {
      return $.ajax({
        url: api,
        jsonp: 'callback',
        dataType: 'jsonp',
        type: 'GET',
        cache: true,
        timeout: 2000,
        success(data) {
          return ExpSdkJs.saveExpResponse(data);
        },
        error() {},
        complete() {},
      });
    }
    return undefined;
  };

  ExpSdkJs.saveExpResponse = function (response) {
    let respObj;
    let globalHoldOut;
    const expData = response.experiment;
    const selectedRecipes = response.selectedRecipes;
    if (Array.isArray(expData)) {
      respObj = ExpSdkJs.mapResponse(expData, globalHoldOut, selectedRecipes);
      ExpSdkJs.setExpSession(ExpSdkJs.COMMON.expSessionKey, respObj);
    }
    return respObj;
  };

  ExpSdkJs.mapResponse = function (expData, globalHoldOut, selectedRecipes) {
    const env = ExpSdkJs.env;
    let respObj = {};
    const mappings = {};
    let allTargetURLs = [];
    respObj = expData.reduce((experimentArr, campaign) => {
      // eslint-disable-next-line no-param-reassign
      experimentArr[campaign.analyticsId] = {
        id: campaign.analyticsId,
        tagType: campaign.tagType,
        taggingProvider: campaign.taggingProvider,
        experimentType: campaign.experimentType,
        adobeAutoTagging: campaign.adobeAutoTagging,
        recipes: campaign.recipes.reduce((recipeArr, recipe) => {
          // eslint-disable-next-line no-param-reassign
          recipeArr[recipe.id] = {
            id: recipe.id,
            tagName: recipe.tagName,
          };
          return recipeArr;
        }, {}),
        targetURLs: campaign.targetUrls,
        recipesType: campaign.recipesType,
        subTargets: campaign.subTargets
          ? campaign.subTargets.reduce((subTargetArr, subTarget) => {
            // eslint-disable-next-line no-param-reassign
            subTargetArr[subTarget.id] = {
              id: subTarget.id,
              name: subTarget.name,
              recipes: subTarget.targetedRecipes.reduce((subRecipeArr, subRecipe) => {
                // eslint-disable-next-line no-param-reassign
                subRecipeArr[subRecipe.id] = {};
                return subRecipeArr;
              }, {}),
              targetURLs: subTarget.segments.reduce((segmentsArr, segment) => _.union(segmentsArr, segment.targetURLs), {}),
            };
            return subTargetArr;
          }, {})
          : [],
        qualifiedSubTarget: campaign.qualifiedSubTarget,
      };
      return experimentArr;
    }, {});
    // const allCampaignIds = _.allKeys(_.omit(respObj, ['expires', 'GlobalHoldOut']));
    const allCampaigns = _.map(_.omit(respObj, 'GlobalHoldOut', 'expires'));
    _.forEach(allCampaigns, (campaign) => {
      allTargetURLs = _.union(allTargetURLs, campaign.targetURLs);
    });
    _.forEach(allTargetURLs, (targetUrl) => {
      _.forEach(allCampaigns, (campaign) => {
        if (includes(campaign.targetURLs, targetUrl)) {
          (mappings[targetUrl.targetUrl] || (mappings[targetUrl.targetUrl] = [])).push(campaign.id);
        }
      });
    });
    respObj.urlCampaignMapping = mappings;
    if (selectedRecipes !== null) {
      respObj.selectedRecipes = selectedRecipes;
    }
    respObj.signedInUser = ExpSdkJs.getCookie('macys_online_uid') || ExpSdkJs.getCookie('bloomingdales_online_uid') || 0;
    if (globalHoldOut) {
      respObj.GlobalHoldOut = globalHoldOut;
    }
    if (env === 'DESKTOP') {
      respObj.expires = new Date().getTime() + ExpSdkJs.COMMON.sessionTTL;
    } else {
      respObj.expires = new Date().getTime() + ExpSdkJs.MEW.sessionTTL;
    }
    return respObj;
  };
  ExpSdkJs.isExpSessionExpired = function () {
    const session = ExpSdkJs.getExpSession(ExpSdkJs.COMMON.expSessionKey);
    const now = new Date().getTime();
    // Remove Session Variable when expire
    // ttl = expire - now
    if (session && session.expires - now < 0) {
      ExpSdkJs.removeExpSession(ExpSdkJs.COMMON.expSessionKey);
      return true;
    }
    return false;
  };

  ExpSdkJs.isExpTagsSessionExpired = function () {
    const session = ExpSdkJs.getExpTagsSession(ExpSdkJs.COMMON.expTagsSessionKey);
    const now = new Date().getTime();
    // Remove Session Variable when expire
    // ttl = expire - now
    if (session && session.split('|')[1] - now < 0) {
      ExpSdkJs.removeExpTagsSession(ExpSdkJs.COMMON.expTagsSessionKey);
      return true;
    }
    return false;
  };
  /*
    Check if the signed In user has changed
  */
  ExpSdkJs.isSignedInSame = function () {
    const brand = ExpSdkJs.brand;
    const session = ExpSdkJs.getExpSession(ExpSdkJs.COMMON.expSessionKey);
    let cookieVal;

    if (brand && brand === 'bcom') {
      cookieVal = ExpSdkJs.getCookie('bloomingdales_online_uid');
    } else {
      cookieVal = ExpSdkJs.getCookie('macys_online_uid');
    }
    if (cookieVal === undefined || cookieVal === null) {
      cookieVal = 0;
    }
    if (session !== undefined && session.signedInUser !== undefined && cookieVal === session.signedInUser) {
      return true;
    }

    return false;
  };
  ExpSdkJs.setExpSession = function (sessionName, data) {
    ClientSideStorage.setSession(sessionName, JSON.stringify(data));
  };
  ExpSdkJs.getExpSession = function (sessionName) {
    if (ClientSideStorage.getSession(sessionName)) {
      return JSON.parse(ClientSideStorage.getSession(sessionName));
    }
    return undefined;
  };
  ExpSdkJs.removeExpSession = function (sessionName) {
    ClientSideStorage.removeSession(sessionName);
  };

  ExpSdkJs.setExpTagsSession = function (sessionName, data) {
    ClientSideStorage.setSession(sessionName, data);
  };
  ExpSdkJs.getExpTagsSession = function (sessionName) {
    if (ClientSideStorage.getSession(sessionName)) {
      return (ClientSideStorage.getSession(sessionName));
    }
    return undefined;
  };
  ExpSdkJs.removeExpTagsSession = function (sessionName) {
    ClientSideStorage.removeSession(sessionName);
  };
  ExpSdkJs.isRecipeSelected = function (expId) {
    ExpSdkJs.init();
    const defObj = $.Deferred();
    const expArray = ExpSdkJs.getExpIds();
    if (expArray !== undefined && expArray.length > 0 && expArray.indexOf(expId) > -1) {
      defObj.resolve(true);
    } else {
      defObj.resolve(false);
    }
    defObj.promise();
    return defObj;
  };
  ExpSdkJs.addCMPipeDelimited = function (value, attribute) {
    if (_.isUndefined(value)) {
      return attribute;
    }
    if (attribute != null && attribute) {
      return value ? `${attribute}|${value.toString()}` : attribute;
    }
    return value.toString();
  };
  ExpSdkJs.populateTags = function (array, session, tag, type) {
    let attr3Val = '';
    let linkClickVal = '';
    const brand = ExpSdkJs.brand;
    if (tag.pageViewTags && tag.pageViewTags !== '') {
      attr3Val = tag.pageViewTags;
    }
    if (tag.linkClickTags && tag.linkClickTags !== '') {
      linkClickVal = tag.linkClickTags;
    }
    _.forEach(array, (val) => {
      const campaignId = val.substring(0, val.indexOf('-')); // i.e. 16
      const recipeId = val; // i.e. 16-10

      if (session[campaignId] && session[campaignId].recipes[recipeId]) {
        // if campaign is found in array
        // if the given recipe is target to the page/url or .*(all pages), then populate the tags
        const location = ExpSdkJs.getLocation().pathname;
        let containsTargetUrl = false;
        let queryParamMatches = false;

        _.forEach(session[campaignId].targetURLs, (url) => {
          if (session[campaignId] && session[campaignId].targetURLs && session[campaignId].targetURLs.length !== 0) {
            if (ExpSdkJs.isDesktopQueryParamSatisfied(url)) {
              queryParamMatches = true;
            }
          } else {
            queryParamMatches = true;
          }
          // eslint-disable-next-line no-mixed-operators
          if (
            (queryParamMatches && location === url.targetUrl) ||
              url.targetUrl === '.*' ||
              (queryParamMatches && location.indexOf(url.targetUrl) > -1 && url.targetUrl !== '/')
          ) {
            containsTargetUrl = true;
            return true;
          }
          return false;
        });
        if (brand === 'mcom') {
          if (session[campaignId].targetURLs && containsTargetUrl) {
            const tagName = session[campaignId].recipes[recipeId].tagName;
            if (tagName !== undefined && tagName !== '' && session[campaignId].tagType === 'Page View') {
              if (tagName.charAt(0) === type && !ExpSdkJs.isTagFired(tagName)) {
                attr3Val = ExpSdkJs.addCMPipeDelimited(attr3Val, tagName || `tagName unavailable for: ${recipeId}`);
                // eslint-disable-next-line no-param-reassign
                tag.pageViewTags = attr3Val;
              }
            } else if (tagName !== undefined && tagName !== '' && session[campaignId].tagType === 'Link Click') {
              // only retrieve tags with autoTag 'on'
              if (tagName.split('EXPERIMENT_')[1].charAt(0) === type && !ExpSdkJs.isTagFired(tagName)) {
                linkClickVal = ExpSdkJs.addCMPipeDelimited(linkClickVal, tagName || `tagName unavailable for: ${recipeId}`);
                // eslint-disable-next-line no-param-reassign
                tag.linkClickTags = linkClickVal;
              }
            }
          }
        } else if (brand === 'bcom') {
          const tagName = session[campaignId].recipes[recipeId].tagName;
          if (tagName !== undefined && tagName !== '' && session[campaignId].tagType === 'Page View') {
            if (tagName.charAt(0) === type && !ExpSdkJs.isTagFired(tagName)) {
              attr3Val = ExpSdkJs.addCMPipeDelimited(attr3Val, tagName || `tagName unavailable for: ${recipeId}`);
              // eslint-disable-next-line no-param-reassign
              tag.pageViewTags = attr3Val;
            }
          } else if (tagName !== undefined && tagName !== '' && session[campaignId].tagType === 'Link Click') {
            // only retrieve tags with autoTag 'on'
            if (tagName.split('EXPERIMENT_')[1].charAt(0) === type && !ExpSdkJs.isTagFired(tagName)) {
              linkClickVal = ExpSdkJs.addCMPipeDelimited(linkClickVal, tagName || `tagName unavailable for: ${recipeId}`);
              // eslint-disable-next-line no-param-reassign
              tag.linkClickTags = linkClickVal;
            }
          }
        }
      }
    });
  };

  ExpSdkJs.getUrlParameters = function () {
    const qsArray = ExpSdkJs.getLocation()
      .search.slice(1)
      .split('&');

    return _.chain(qsArray)
      .map((item) => {
        if (item) {
          const paramMap = item.split('=');
          if (!_.isEmpty(paramMap)) {
            paramMap[0] = paramMap[0].toLowerCase();
          }
          return paramMap;
        }
        return undefined;
      })
      .compact()
      .object()
      .value();
  };

  ExpSdkJs.isMEWQueryParamSatisfied = function (session, recipeId, url) {
    const params = ExpSdkJs.getUrlParameters();
    let isSatisfied = true;
    _.forEach(session[recipeId][url], (qryParam) => {
      if (params[qryParam.key]) {
        // eslint-disable-next-line default-case
        switch (qryParam.operator) {
          case 'EQUALS':
            if (params[qryParam.key] !== qryParam.value) {
              isSatisfied = false;
            }
            break;
          case 'NOTEQUALS':
            if (params[qryParam.key] === qryParam.value) {
              isSatisfied = false;
            }
            break;
          case 'CONTAINS':
            if (qryParam.value !== '*' && params[qryParam.key].indexOf(qryParam.value) < 0) {
              isSatisfied = false;
            }
            break;
          case 'NOTCONTAIN':
            if (qryParam.value !== '*' && params[qryParam.key].indexOf(qryParam.value) > 0) {
              isSatisfied = false;
            }
            break;
          case 'STARTSWITH':
            if (params[qryParam.key].indexOf(qryParam.value) < 1) {
              isSatisfied = false;
            }
            break;
        }
      }
      if (!isSatisfied) {
        return false;
      }
      return undefined;
    });
    return isSatisfied;
  };

  // .toLowerCase()
  ExpSdkJs.isDesktopQueryParamSatisfied = function (url) {
    const params = ExpSdkJs.getUrlParameters();
    let isSatisfied = true;
    _.forEach(url.queryParams, (qryParam) => {
      if (params[qryParam.key]) {
        // eslint-disable-next-line default-case
        switch (qryParam.operator) {
          case 'EQUALS':
            if (params[qryParam.key] !== qryParam.value) {
              isSatisfied = false;
            }
            break;
          case 'NOTEQUALS':
            if (params[qryParam.key] === qryParam.value) {
              isSatisfied = false;
            }
            break;
          case 'CONTAINS':
            if (qryParam.value !== '*' && params[qryParam.key].indexOf(qryParam.value) < 0) {
              isSatisfied = false;
            }
            break;
          case 'NOTCONTAIN':
            if (qryParam.value !== '*' && params[qryParam.key].indexOf(qryParam.value) > 0) {
              isSatisfied = false;
            }
            break;
          case 'STARTSWITH':
            if (params[qryParam.key].indexOf(qryParam.value) < 1) {
              isSatisfied = false;
            }
            break;
        }
      }
      if (!isSatisfied) {
        return false;
      }
      return undefined;
    });
    return isSatisfied;
  };
  ExpSdkJs.isTagFired = function (tagName) {
    const firedLinkClickTags = ClientSideStorage.getSession(tagName);
    const sessionExists = !!firedLinkClickTags;
    // if not in session (first time fired): store in session
    if (!sessionExists) {
      return false;
    }
    return true;
  };
  ExpSdkJs.sessionBasedLinkClickTagFired = function (tagName) {
    ClientSideStorage.setSession(tagName, new Date().toString());
  };
  ExpSdkJs.isArray = function (array) {
    if (Array.isArray(array) && array !== undefined && array.length !== 0 && array[0] !== '') {
      return true;
    }
    return false;
  };
  ExpSdkJs.getDesktopServerSideExperiments = function () {
    const cookie = Cookie.get(ExpSdkJs.COMMON.expCookieName);
    let parsedExpString;
    let expArray = [];
    if (cookie && decodeURIComponent(cookie).indexOf('|') > 1) {
      parsedExpString = decodeURIComponent(cookie).split('|')[2];
    }
    if (parsedExpString) {
      expArray = parsedExpString.split(',');
    }
    return expArray;
  };
  ExpSdkJs.getTags = function (recipeIds, t) {
    ExpSdkJs.init();
    let type = t;
    let expArray = [];
    const tag = {
      pageViewTags: '',
      linkClickTags: '',
    };
    const defObj = $.Deferred();

    const defObj2 = $.Deferred();

    if (!t || (t !== 'A' && t !== 'M')) {
      // Reject anything or override with Auto in case of any junk values
      type = 'A';
    }
    if (recipeIds && recipeIds.length > 0) {
      expArray = recipeIds;
      defObj2.resolve();
    } else if (type === 'A') {
      expArray = ExpSdkJs.getExpIds();
      defObj2.resolve();
    } else {
      expArray = [];
      defObj2.resolve();
    }
    defObj2.promise().then(() => {
      const session = ExpSdkJs.getExpSession(ExpSdkJs.COMMON.expSessionKey);
      if (!session || ExpSdkJs.isExpSessionExpired() || !ExpSdkJs.isSignedInSame()) {
        ExpSdkJs.fetchExpData().always((newSession) => {
          if (newSession) {
            ExpSdkJs.populateTags(expArray, newSession, tag, type);
            defObj.resolve(tag);
          } else {
            defObj.reject(tag);
          }
        });
      } else if (ExpSdkJs.isArray(expArray)) {
        ExpSdkJs.populateTags(expArray, session, tag, type);
        defObj.resolve(tag);
      } else {
        defObj.reject(tag);
      }
    });
    defObj.promise();
    return defObj;
  };

  ExpSdkJs.getFinalClientRecipes = function () {
    return new Promise(resolve => ExpSdkJs.getAllSelectedRecipes().always(() => {
      ExpSdkJs.init();
      const session = ExpSdkJs.getExpSession(ExpSdkJs.COMMON.expSessionKey);
      const allSeedExps = ExpSdkJs.getExpIds();
      const finalClientRecipes = [];
      if (session) {
        _.forEach(allSeedExps, (exp) => {
          const expId = exp.split('-', 1);
          if (session[expId] && session[expId].taggingProvider) {
            if (session[expId].taggingProvider === 'Both' || session[expId].taggingProvider === 'Adobe') {
              if (session[expId].adobeAutoTagging === true || session[expId].adobeAutoTagging === null ||
                 session[expId].adobeAutoTagging === undefined) {
                finalClientRecipes.push(exp);
              }
            }
          }
        });
      }
      resolve(finalClientRecipes);
    }));
  };

  ExpSdkJs.fireDesktopAdobeTags = function () {
    ExpSdkJs.getFinalClientRecipes().then((finalRecipes) => {
      const defObj = $.Deferred();
      const defObj2 = $.Deferred();
      const filterFinalRecipes = [];
      let sessionRecipes = [];
      let sessionRecipesList = [];
      const updatedRecipes = [];
      const expTagsSession = ExpSdkJs.getExpTagsSession(ExpSdkJs.COMMON.expTagsSessionKey);
      if (expTagsSession && !ExpSdkJs.isExpTagsSessionExpired()) {
        _.forEach(finalRecipes, (recipe) => {
          sessionRecipes = expTagsSession.split('|')[0];
          if (sessionRecipes) {
            sessionRecipesList = sessionRecipes.split(',');
          }
          if (!(_.contains(sessionRecipesList, recipe))) {
            filterFinalRecipes.push(recipe);
          }
        });
        const data = {
          event_name: 'experiment',
          experimentation_ids: filterFinalRecipes,
        };
        if (filterFinalRecipes.length > 0) {
          TagManagerUtil.fireTag('link', data);
          defObj.resolve();
        }
        defObj.promise().then(() => {
          updatedRecipes.push(sessionRecipesList);
          updatedRecipes.push(filterFinalRecipes);
          const existingTtl = expTagsSession.split('|')[1];
          const updatedExp = `${updatedRecipes}|${existingTtl}`;
          ExpSdkJs.setExpTagsSession(ExpSdkJs.COMMON.expTagsSessionKey, updatedExp);
        });
      } else {
        const data2 = {
          event_name: 'experiment',
          experimentation_ids: finalRecipes,
        };
        if (finalRecipes.length > 0) {
          TagManagerUtil.fireTag('link', data2);
          defObj2.resolve();
        }
        defObj2.promise().then(() => {
          const ttl = new Date().getTime() + ExpSdkJs.COMMON.expTagssessionTTL;
          const exp = `${finalRecipes}|${ttl}`;
          ExpSdkJs.setExpTagsSession(ExpSdkJs.COMMON.expTagsSessionKey, exp);
        });
      }
    });
  };

  ExpSdkJs.fireAdobeTags = function () {
    ExpSdkJs.fireDesktopAdobeTags();
  };


  ExpSdkJs.getNoneTags = function (array, type) {
    ExpSdkJs.init();
    let attr3Val = '';
    let linkClickVal = '';
    const session = ExpSdkJs.getExpSession(ExpSdkJs.COMMON.expSessionKey);
    _.forEach(array, (noneCamp) => {
      let tagName = '';
      if (session && session[noneCamp] && session[noneCamp].qualifiedSubTarget) {
        tagName = ExpSdkJs.getTagNameForTargeted(session, noneCamp);
      } else {
        tagName = ExpSdkJs.getTagNameForRegular(session, noneCamp);
      }
      if (session && session[noneCamp] && session[noneCamp].tagType === 'Page View' && tagName) {
        attr3Val = ExpSdkJs.addCMPipeDelimited(attr3Val, tagName);
      } else if (session && session[noneCamp] && session[noneCamp].tagType === 'Link Click' && tagName) {
        linkClickVal = ExpSdkJs.addCMPipeDelimited(linkClickVal, tagName);
      }
    });
    if (type === 'PV') {
      // Page View.
      return attr3Val;
    }
    if (type === 'LC') {
      // Link Click
      return linkClickVal;
    }
    return undefined;
  };


  ExpSdkJs.replaceMEWQueryParamRecipes = function (queryParamRecipes, mexExpArr) {
    const objArray = [];
    const repArray = [];
    const listOfRecipes = mexExpArr;
    let tempSessionStorage = mexExpArr;
    _.forEach(queryParamRecipes, (replacement) => {
      const queryParamId = replacement.split('-')[0];
      const theObj = _.find(listOfRecipes, (existingRecipe) => {
        const existingRecipeId = existingRecipe.split('-')[0];
        return queryParamId === existingRecipeId;
      });
      if (theObj) {
        if (theObj !== replacement) {
          repArray.push(replacement);
          objArray.push(theObj);
        }
      } else {
        tempSessionStorage.push(replacement);
      }
    });

    if (repArray && objArray && repArray.length > 0 && objArray.length > 0) {
      _.forEach(repArray, (rep) => {
        tempSessionStorage.push(rep);
      });
      _.forEach(objArray, (obj) => {
        tempSessionStorage = _.without(tempSessionStorage, obj);
      });
    }
    return tempSessionStorage;
  };
  module.exports = ExpSdkJs;
}



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@component/experiment/src/js/ExperimentationSDK.js